module.exports = __webpack_public_path__ + "img/6.c124b07d.jpeg";